/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Runtimestatus1Inputs */

const en__field_runtimestatus1 = /** @type {(inputs: _Field_Runtimestatus1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runtime Status`)
};

const de__field_runtimestatus1 = /** @type {(inputs: _Field_Runtimestatus1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laufzeitstatus`)
};

/**
* | output |
* | --- |
* | "Runtime Status" |
*
* @param {_Field_Runtimestatus1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_runtimestatus1 = /** @type {((inputs?: _Field_Runtimestatus1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Runtimestatus1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_runtimestatus1(inputs)
	return de__field_runtimestatus1(inputs)
});
export { _field_runtimestatus1 as "_field_runtimeStatus" }